export default function CtaSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          Ready to Discover Amazing Finds?
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
          Join thousands of shoppers who use Kakobuy Spreadsheet to find verified products, compare options, and shop smarter every day.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap"
          >
            Kakobuy Sheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-all whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>
      </div>
      <div className="mt-14 w-full overflow-hidden">
        <div className="flex gap-4 px-4">
          <div className="flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20stylish%20fashion%20item%20on%20cream%20background%2C%20minimal%20isolated%20product%20shot%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20tones%2C%20editorial%20catalog%20style%2C%20simple%20composition%2C%20high%20quality%20detail%2C%20e-commerce%20product%20display&width=400&height=300&seq=bottom-strip-01&orientation=landscape"
              alt="Kakobuy Spreadsheet product find 1"
              title="Kakobuy Spreadsheet Find 1"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20trendy%20accessory%20item%20on%20light%20beige%20background%2C%20soft%20daylight%2C%20isolated%20product%20shot%2C%20warm%20neutral%20tones%2C%20editorial%20e-commerce%20style%2C%20clean%20composition%2C%20high%20quality%20detail&width=400&height=300&seq=bottom-strip-02&orientation=landscape"
              alt="Kakobuy Spreadsheet product find 2"
              title="Kakobuy Spreadsheet Find 2"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20modern%20footwear%20on%20cream%20background%2C%20minimal%20isolated%20shot%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20tones%2C%20editorial%20catalog%20style%2C%20clean%20simple%20composition%2C%20high%20quality%20detail%2C%20e-commerce%20display&width=400&height=300&seq=bottom-strip-03&orientation=landscape"
              alt="Kakobuy Spreadsheet product find 3"
              title="Kakobuy Spreadsheet Find 3"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20elegant%20bag%20on%20light%20background%2C%20minimal%20isolated%20shot%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20tones%2C%20editorial%20catalog%20style%2C%20clean%20composition%2C%20high%20quality%20detail%2C%20e-commerce%20product%20display&width=400&height=300&seq=bottom-strip-04&orientation=landscape"
              alt="Kakobuy Spreadsheet product find 4"
              title="Kakobuy Spreadsheet Find 4"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20casual%20apparel%20item%20on%20cream%20background%2C%20minimal%20isolated%20shot%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20tones%2C%20editorial%20catalog%20style%2C%20clean%20composition%2C%20high%20quality%20detail%2C%20e-commerce%20display&width=400&height=300&seq=bottom-strip-05&orientation=landscape"
              alt="Kakobuy Spreadsheet product find 5"
              title="Kakobuy Spreadsheet Find 5"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20stylish%20headwear%20on%20beige%20background%2C%20minimal%20isolated%20shot%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20tones%2C%20editorial%20catalog%20style%2C%20clean%20composition%2C%20high%20quality%20detail%2C%20e-commerce%20display&width=400&height=300&seq=bottom-strip-06&orientation=landscape"
              alt="Kakobuy Spreadsheet product find 6"
              title="Kakobuy Spreadsheet Find 6"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20luxury%20perfume%20bottle%20on%20cream%20background%2C%20minimal%20isolated%20shot%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20tones%2C%20editorial%20catalog%20style%2C%20clean%20composition%2C%20high%20quality%20detail%2C%20e-commerce%20display&width=400&height=300&seq=bottom-strip-07&orientation=landscape"
              alt="Kakobuy Spreadsheet product find 7"
              title="Kakobuy Spreadsheet Find 7"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20sportswear%20item%20on%20light%20background%2C%20minimal%20isolated%20shot%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20tones%2C%20editorial%20catalog%20style%2C%20clean%20composition%2C%20high%20quality%20detail%2C%20e-commerce%20display&width=400&height=300&seq=bottom-strip-08&orientation=landscape"
              alt="Kakobuy Spreadsheet product find 8"
              title="Kakobuy Spreadsheet Find 8"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}